<template>
  <FormulateInput
    ref="suggestion-select"
    v-bind="field"
    v-model="localValue"
    :options="options"
    :disabled="disabled"
    @input="$emit('input', $event)"
    @addTag="handleAddTag"
    @open="handleOpen"
  />
</template>

<script>
import * as SalesOrder from '@/services/rest-api/lib/sales-order/sales-order.js'

export default {
  props: {
    value: {
      type: [Object, String, Number],
      default: () => {},
    },
    field: {
      type: Object,
      default: () => {},
    },
    // Examples of the field for suggestion select input
    // field: {
    //   name: 'customer_name',
    //   placeholder: 'Masukkan Nama Pelanggan',
    //   type: 'taggable-select-input',
    //   label: 'Nama Pelanggan',
    //   labelKey: 'value',
    //   validation: [
    //     ['bail'],
    //     ['optional'],
    //     ['min', 2],
    //     ['max', 144],
    //   ],
    //   optionLabelFn: (item) => item.item.value
    // },
    customerName: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['input', 'open'],
  data() {
    return {
      options: [],
      oldCustomerName: null,
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      },
    },
  },
  methods: {
    handleAddTag(event) {
      this.options.push(event)
    },

    async handleOpen() {
      if (this.options.length > 0 && (this.oldCustomerName && this.customerName === this.oldCustomerName)) return

      const queryParam = {}

      if (this.customerName && this.customerName !== '') {
        queryParam.customerName = this.customerName
        this.oldCustomerName = this.customerName
      }

      const res = await SalesOrder.getSuggestions(this.field.key.replaceAll('_', '-'), queryParam)

      this.options = res.data.suggestions
    },
  },
}
</script>
